import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { isNil } from '@web/utils';
import { EntryNotFoundException } from '@web/common';
import { SelectItem } from '@web/shared/ui';
import { WarehouseReleaseStatus } from '../enums/warehouse-release-status';

@Injectable({
  providedIn: 'root',
})
export class WarehouseReleaseStatusProviderService {
  private entries = new Map<WarehouseReleaseStatus, string>([
    [WarehouseReleaseStatus.Approved, 'Zatwierdzony'],
    [WarehouseReleaseStatus.Draft, 'Szkic'],
  ]);

  public label(status: WarehouseReleaseStatus): Observable<string> {
    const entry = this.entries.get(status);

    if (isNil(entry)) {
      throw new EntryNotFoundException(`The entry for "${status}" not found.`);
    }

    return of(entry);
  }

  public selectItems(): Observable<SelectItem<WarehouseReleaseStatus>[]> {
    const result = Array.from(this.entries.entries()).map(
      ([status, label]) => new SelectItem(label, status),
    );

    return of(result);
  }
}
